import React, { useState } from 'react'
import { PatientHistoryType } from 'src/graphql.generated'
import { useSubmitPatientHistory } from '../../../../api/useSubmitPatientHistory'
import {
  FieldGrid,
  FieldSection,
  FormActions,
  LabeledDate,
  LabeledRadioGroup,
  todayIso,
  useRequiredFields,
} from '../../../fieldPrimitives'
import { BURNOUT_OPTIONS } from '../../historyOptions'

type BurnoutScore = '1' | '2' | '3' | '4' | '5'

// The Maslach single-item burnout scale, verbatim from `BurnoutForm.tsx`.

const BurnoutFields = ({ uid }: { uid: string }) => {
  const [date, setDate] = useState(todayIso())
  const [score, setScore] = useState<BurnoutScore | ''>('')
  const { submit, submitting, error } = useSubmitPatientHistory(uid)
  const required = useRequiredFields({ 'Date of event': Boolean(date), 'Burnout Questionnaire': Boolean(score) })

  const onSubmit = async () => {
    if (!required.attempt()) {
      return
    }

    await submit({ date, type: PatientHistoryType.Burnout, value: { BURNOUT_SCORE: Number(score) } })
    setScore('')
    required.reset()
  }

  return (
    <FieldSection>
      <FieldGrid>
        <LabeledDate
          label="Date of event"
          value={date}
          onChange={setDate}
          required
          error={required.error('Date of event')}
        />
      </FieldGrid>
      <LabeledRadioGroup
        label="Burnout Questionnaire"
        value={score}
        onChange={setScore}
        options={BURNOUT_OPTIONS}
        required
        error={required.error('Burnout Questionnaire')}
      />
      <FormActions onSubmit={onSubmit} disabled={false} submitting={submitting} error={error} />
    </FieldSection>
  )
}

export default BurnoutFields
